import * as tslib_1 from "tslib";
import { Flat } from './flat';
var ListView = /** @class */ (function (_super) {
    tslib_1.__extends(ListView, _super);
    function ListView(param) {
        return _super.call(this, param) || this;
    }
    ListView.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "ListView" });
    };
    ListView.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ListView;
}(Flat));
export { ListView };
//# sourceMappingURL=list_view.js.map